export default {
  'http.300': 'Multiple Choices',
  'http.301': 'Moved Permanently',
  'http.302': 'Found',
  'http.303': 'See Other',
  'http.304': 'Not Modified',
  'http.305': 'Use Proxy',
  'http.306': 'Switch Proxy',
  'http.307': 'Temporary Redirect',
  'http.308': 'Permanent Redirect',
  'http.400': 'Bad Request',
  'http.401': 'Unauthorized',
  'http.402': 'Payment Required',
  'http.403': 'Forbidden',
  'http.404': 'Not Found',
  'http.405': 'Method Not Allowed',
  'http.406': 'Not Acceptable',
  'http.407': 'Proxy Authentication Required',
  'http.408': 'Request Timeout',
  'http.409': 'Conflict',
  'http.410': 'Gone',
  'http.411': 'Length Required',
  'http.412': 'Precondition Failed',
  'http.413': 'Payload Too Large',
  'http.414': 'URI Too Long',
  'http.415': 'Unsupported Media Type',
  'http.416': 'Range Not Satisfiable',
  'http.417': 'Expectation Failed',
  'http.418': "I'm a teapot",
  'http.421': 'Misdirected Request',
  'http.422': 'Unprocessable Entity',
  'http.423': 'Locked',
  'http.424': 'Failed Dependency',
  'http.425': 'Too Early',
  'http.426': 'Upgrade Required',
  'http.428': 'Precondition Required',
  'http.429': 'Too Many Requests',
  'http.431': 'Request Header Fields Too Large',
  'http.451': 'Unavailable For Legal Reasons',
  'http.500': 'Internal Server Error',
  'http.501': 'Not Implemented',
  'http.502': 'Bad Gateway',
  'http.503': 'Service Unavailable',
  'http.504': 'Gateway Timeout',
  'http.505': 'HTTP Version Not Supported',
  'http.506': 'Variant Also Negotiates',
  'http.507': 'Insufficient Storage',
  'http.508': 'Loop Detected',
  'http.510': 'Not Extended',
  'http.511': 'Network Authentication Required'
}
